var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import IconContainer, { IconSVG } from "./IconContainer";
var IconPublished = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("path", { d: "M21.3,4.7H5.4c-1.2,0-2.2,1-2.2,2.2v11.9 M26.7,18.7V6.8c0-1.2-1-2.2-2.2-2.2h-3.2\n\t M21.3,24.2h3.2c1.2,0,2.2-1,2.2-2.2v-3.2 M3.2,18.7V22c0,1.2,1,2.2,2.2,2.2h3.2" }),
            React.createElement("path", { d: "M3.3,10.9h23.5" }),
            React.createElement("g", { transform: "translate(2.834 2.833)" },
                React.createElement("circle", { cx: "4.3", cy: "5", r: "1" }),
                React.createElement("circle", { cx: "4.3", cy: "5", r: "0.1" })),
            React.createElement("g", { transform: "translate(5.834 2.833)" },
                React.createElement("circle", { cx: "4.6", cy: "5", r: "1" }),
                React.createElement("circle", { cx: "4.6", cy: "5", r: "0.1" })),
            React.createElement("g", { transform: "translate(8.834 2.833)" },
                React.createElement("circle", { cx: "4.9", cy: "5.1", r: "1" }),
                React.createElement("circle", { cx: "4.9", cy: "5.1", r: "0.1" })),
            React.createElement("path", { d: "M23,16.2l-8,8l-3.6-3.6" }))));
});
export default IconPublished;
//# sourceMappingURL=IconPublished.js.map